import { TabsComponent, PageHeader } from "@/components/molecules";
import { Breadcrumb } from "@/components/atoms";
import { OrderItemRewards, OrderItemTab, OrderItemPriceInfo} from "@/containers";
import { useItemOverview } from "@/hooks/useItemOverview";
import { selectItem } from "@/store/slices/itemSlice";
import { useSelector } from "react-redux";
import { capitalizeFirst } from "@/helpers/shadcn/utils";
import "./ordersItemDetail.scss";

export const OrdersItemDetail = () => {
  const item = useSelector(selectItem); 
  const itemDetails = item?.itemDetail || {}; // Get orderId from URL parameters
  
  const { subItemColConfigData } =
    useItemOverview();

  const tabList = [
    {
      id: "orderItem",
      tabLabel: "Order Item",
      tabComponent: (
        <OrderItemTab
          orderItemTabData={{
            subItemColConfigData,
          }}
          itemDetails={itemDetails}
        />
      ),
    },
    {
      id: "priceInformation",
      tabLabel: "Price Information",
      tabComponent: <OrderItemPriceInfo orderItemPriceInfoData={itemDetails} />,
    },
    {
      id: "rewards",
      tabLabel: "Rewards",
      tabComponent: <OrderItemRewards orderItemRewardData={itemDetails} />
    },
  ];
const breadcrumbs = [
  {
    href: '/',
    label: '',
  },
  {
    href: itemDetails?.orderType ? `/orders/list?type=${itemDetails.orderType.toLowerCase()}` : '',
    label: itemDetails?.orderType ? `${capitalizeFirst(itemDetails.orderType)} Order` : '-',
  },
  {
    href:
      itemDetails?.orderType && itemDetails?.orderId
        ? `/orders/${itemDetails.orderType.toLowerCase()}/${encodeURIComponent(
            itemDetails.orderId.replace(/\s/g, '%20').replace(/\./g, '%2E')
          )}`
        : '',
    label: itemDetails?.orderId || '-',
  },
  {
    href: '',
    label: itemDetails?.item || '-',
  },
]
  return (
    <div className="OrdersItemDetail">
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: "mb-5",
          breadcrumbs,
        }}
        id="itemOverviewBreadcrumb"
      />
      <div className="flex flex-row justify-between">
        <PageHeader title={itemDetails?.item} />
      </div>
      <TabsComponent tabList={tabList} defaultabIndex={0} />
    </div>
  );
};
